module.exports = __webpack_public_path__ + "img/labmemtest_logo_kr.1cd6c7b1.png";